import { useEffect, useState, useRef } from "react"
import { Link, useNavigate } from "react-router-dom";
import styles from './cssModules/index.module.css';
import noProd from './gallary/noProd.png';

export default function ManageProd({ loginStatus }) {

    const apiURL = process.env.REACT_APP_SELLER;
    let jToken = localStorage.getItem('token');
    const userUrl = process.env.REACT_APP_API_URL;
    const navigate = useNavigate();
    const [form, setForm] = useState({});

    const [pageno, setPageno] = useState(1);
    const [noOfObs, setNoOfObs] = useState(null);
    const [prodLs, setProdLs] = useState([]);

    const renderCount = useRef(0);


    const monthVal = {
        1: 'January',
        2: 'February',
        3: 'March',
        4: 'April',
        5: 'May',
        6: 'June',
        7: 'July',
        8: 'August',
        9: 'September',
        10: 'October',
        11: 'November',
        12: 'December',
    }

    const yearVal = Array.from({ length: 10 }, (_, index) => index + 2025);

    useEffect(() => {
        const initFetch = async () => {
            try {
                const response = await fetch(`${apiURL}/api/manage`, {
                    method: 'GET',
                    headers: {
                        'Content-type': 'Application/json',
                        'Authorization': `Bearer ${jToken}`
                    },
                    credentials: 'include'
                })
                if (response.status === 500) {
                    throw new Error('Error while managing products');
                } else {
                    if (response.status !== 200) {
                        await loginStatus();
                        navigate('/login');
                    }
                }
            } catch (error) {
                navigate('/error');
                // await loginStatus();
                console.log(error.message);
            }
        }
        initFetch();
    }, [jToken, loginStatus, apiURL, navigate]);


    async function handleSubmit(event) {
        try {
            event.preventDefault();
            const formdata = new FormData(event.target);
            const formObject = {}
            formdata.forEach((value, key) => {
                formObject[key] = value
            });
            setForm(formObject);
            const response = await fetch(`${apiURL}/api/manage`, {
                method: 'POST',
                headers: {
                    'Content-type': 'Application/json',
                    'Authorization': `Bearer ${jToken}`
                },
                body: JSON.stringify({
                    filterData: formObject,
                    pageNo: pageno
                }),
                credentials: "include"
            })
            if (response.status === 500) {
                throw new Error('Error while fetching product data');
            } else {
                if (response.status === 200) {
                    const res = await response.json();

                    setNoOfObs(res.noObs);
                    setProdLs(res.prod);
                    renderCount.current += 1;
                } else {
                    await loginStatus();
                    navigate('/login');
                }
            }
        } catch (error) {
            // await loginStatus();
            navigate('/error');
            console.log(error.message);
        }
    }

    const changePage = async (event, ind) => {
        try {
            event.preventDefault();
            const increment = !ind ? 1 : -1;
            const response = await fetch(`${apiURL}/api/manage`, {
                method: 'POST',
                headers: {
                    'Content-type': 'Application/json',
                    'Authorization': `Bearer ${jToken}`
                },
                body: JSON.stringify({
                    filterData: form,
                    pageNo: pageno + increment
                }),
                credentials: "include"
            })
            if (response.status === 500) {
                throw new Error('Error occured while changing page');
            } else {
                if (response.status === 200) {
                    const res = await response.json();
                    setNoOfObs(res.noObs);
                    setProdLs(res.prod);
                } else {
                    await loginStatus();
                    navigate('/login');
                }
            }
        } catch (error) {
            // await loginStatus();
            navigate('/error');
            console.log(error.message);
        }
    }

    function deleteProd(id, prod) {
        const fetchData = async () => {
            try {
                const response = await fetch(`${apiURL}/delete`, {
                    method: 'POST',
                    headers: {
                        'Content-type': 'Application/json',
                        'Authorization': `Bearer ${jToken}`
                    },
                    body: JSON.stringify({ id: id, prodType: prod }),
                    credentials: "include"
                })
                if (response.status === 500) {
                    throw new Error('Error occured while deleting product');
                } else {
                    if (response.status === 200) {
                        alert('Item has been deleted!');
                        window.location.reload();
                    } else {
                        alert('Problem occured while deleting item! Try again later');
                    }
                }
            } catch (error) {
                await loginStatus();
                navigate('/login');
                console.log(error.message);
            }
        }
        fetchData();
    }

    const repeatProd = (prodId, prodType) => {
        navigate(`/repeat/${prodType}/${prodId}`)
    }

    return (
        <>
            <div className={`${styles.sellerDashboard}`}>

                <div className={`${styles.sellerManagerDiv}`}>
                    <span style={{ fontSize: '20px', fontWeight: '700', letterSpacing: '1px' }}>Modify your products by date</span>
                    <form id='selectDate' onSubmit={handleSubmit} className={`${styles.sellerDBForm}`}>
                        <div className={`${styles.sellerDBSelectionDiv}`}>
                            <select name='month' form="selectDate" className={`${styles.sellerDBformSelect}`}>
                                {Object.entries(monthVal).map((elem) => {
                                    return (
                                        <>
                                            <option value={elem[0]} key={elem}>{elem[1]}</option>
                                        </>
                                    )
                                })}
                            </select>
                            <select name='year' form="selectDate" className={`${styles.sellerDBformSelect}`}>
                                {yearVal.map((elem) => {
                                    return (
                                        <>
                                            <option value={elem} key={elem}>{elem}</option>
                                        </>
                                    )
                                })}
                            </select>
                        </div>
                        <input type="submit" value='CHECK' className={`${styles.sellerDBforminput}`} />
                    </form>
                </div>
            </div>

            {
                (prodLs.length === 0) && (renderCount.current > 0) ?
                    (<>
                        <div className={`${styles.noNotificationDivSelect}`}>
                            <span className={`${styles.noNotificationSpan}`}>
                                No activity
                            </span>
                            <img src={noProd} alt='Inactivity' style={{ height: '60px' }} />
                        </div>
                    </>) :
                    (
                        <div>
                            <div className={`${styles.sellerDBPRODLS}`}>
                                {prodLs.length > 0 && prodLs.map((item, index) => {
                                    return (
                                        <>
                                            <div className={`${styles.sellerManageIMGDiv}`} style={item.status === false? {background: "#f19393"}: {}}>
                                                <Link className={`${styles.sellerReturnDBAnchor}`} to={`${userUrl}/product/${item.prod}/${item.id}`} target="_blank">
                                                    <img className={`${styles.sellerDBPRODIMG}`} id={index} src={`${process.env.REACT_APP_S3_URL}/${item.photo1}`} alt={index}></img>
                                                    <span className={`${styles.sellerReturnDBFont}`}>{item.name}</span>
                                                    <span>Price: {item.price}</span>
                                                </Link>
                                                <div className={`${styles.sellerManageBTNDiv}`}>
                                                    <button className={`${styles.sellermanageBTN}`} onClick={() => navigate(`/update/${item.prod}/${item.id}`)}>UPDATE</button>
                                                    {/* <button onClick={()=>console.log(item.id)}>Update</button> */}
                                                    <button className={`${styles.sellermanageBTN}`} onClick={() => deleteProd(item.id, item.prod)}>DELETE</button>
                                                    <button className={`${styles.sellermanageBTN}`} onClick={() => repeatProd(item.id, item.prod)}>REPEAT</button>
                                                    {item.review === true
                                                        ? <div className={`${styles.reviewPendingTag}`}>
                                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#2196f3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                                <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
                                                            </svg>
                                                            Review is pending
                                                          </div>
                                                        : item.remark && <div className={`${styles.remarkTag}`}>
                                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
                                                            </svg>
                                                            {item.remark}
                                                          </div>
                                                    }
                                                </div>
                                            </div>
                                        </>
                                    )
                                })}
                            </div>
                            <div style={noOfObs < 20 ? { display: 'none' } : { display: 'block' }}>
                                <button onClick={(e) => { changePage(e, true); setPageno(pageno - 1) }} style={pageno < 2 ? { display: 'none' } : { display: 'block' }}
                                    disabled={pageno < 2 ? true : false}>Prev</button>
                                <span>{pageno}</span>
                                <button onClick={(e) => { changePage(e, false); setPageno(pageno + 1) }}
                                    disabled={noOfObs <= pageno * 20}>Next</button>
                            </div>
                        </div>
                    )}
        </>
    )
}